/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.staffToggle)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.staffToggle = exports.storySlider = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// storySlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var storySlider = function storySlider() {
	  $(".gallery-list").each(function (i) {
	    $(this).slick({
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      arrows: true,
	      dots: true,
	      speed: 500,
	      cssEase: 'ease',
	      variableWidth: true,
	      appendArrows: '#slideNav_Wrap-' + i,
	      appendDots: '#slideNav_Dots-' + i,
	      responsive: [{
	        breakpoint: 768,
	        settings: {
	          slidesToShow: 1,
	          swipeToSlide: true,
	          swipe: true,
	          edgeFriction: 0.01
	        }
	      }]
	    });
	  });
	}; // ------------------------------------------------------------------------
	// staffToggle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.storySlider = storySlider;
	
	var staffToggle = function staffToggle() {
	  var tabs = $(".tab-item a");
	  $(".tab-item a").on("click", function () {
	    // tabをクリックしたらイベント発火
	    $(".current").removeClass("current"); // currentクラスを消す
	
	    $(this).addClass("current"); // クリックした箇所にactiveクラスを追加
	
	    var index = tabs.index(this); // クリックした箇所がタブの何番目か判定し、定数indexとして定義
	
	    $(".tab-content").removeClass("show").eq(index).addClass("show"); // showクラスを消して、contentクラスのindex番目にshowクラスを追加
	  });
	};
	
	exports.staffToggle = staffToggle;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// staff/app.bundle.js